import { Types } from "actions/ai-call-jobs";
import { createReducer } from "utils/reducer";
import { propOr } from "ramda";
// import { createSelector } from "reselect";

export default createReducer([], {
  [Types.GET_AI_JOBS_RESPONSE]: (state, action) =>
    propOr([], "response", action)
});

export const selectors = {
  getAICallJobs: state => state.get("ai-call-jobs")
};
